<template>
  <div class="container table-data">
    <a id="downLoad" style="display: none !important;" :href="downloadUrl" :download="downloadName"></a>
    <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="addQuery" ref="queryForm">
      <el-form-item label="报表名称：" prop="type">

        <el-select v-model="addQuery.name" placeholder="全部">
          <el-option v-for="item in nameList" :label="item.name" :value="item.code" :key="item.idx"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日期：" prop="date" label-width="80px">
        <el-date-picker
            v-model="addQuery.dateRange"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            placeholder="请选择日期">
        </el-date-picker>
      </el-form-item>
<!--      <el-form-item>-->
<!--        <el-button type="primary" @click="fetch">查询</el-button>-->
<!--      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" @click="addItem">生成报表</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="refresh">重置</el-button>
      </el-form-item>
    </el-form>
    <p style="font-size: 12px;padding-bottom: 16px;padding-top: 20px;">提示：报表生成需要一点时间，手动刷新网页查看报表最新状态</p>
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%">
      <el-table-column label="编号" type="index" :index="indexMethod"></el-table-column>
      <el-table-column
          v-for="(item, index) in tableColumn"
          :prop="item.id"
          :label="item.name"
          :show-overflow-tooltip="true"
          :key="index"
          :width="item.width">
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span v-if="!scope.row.status" style="color: #ff9900">查询中</span>
          <span v-else>已完成</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button size="mini" class="tab-btn" type="text" v-if="scope.row.status" @click="downloadItem(scope.row)">下载报表</el-button>
          <el-button size="mini"
             @click.native.prevent="deleteItem(scope.row)"
             type="text">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNo"
        :page-sizes="pageSizes"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total">
    </el-pagination>
  </div>
</template>

<script>
import * as _ from "lodash";
import { Loading } from 'element-ui';

export default {
  name: "school",
  data () {
    return {
      loading: false,
      downloadUrl: '',
      downloadName: '',
      userId: '',
      nameList: [
        { name: '上师大合并报表', code: '上师大合并报表', idx: 0, },
      ],
      pageSizes: [10,20,30,40,50],//自定义分页条数
      queryFormLabelWidth: '100px',//自定义查询表单label宽度
      addQuery: {
        name: '',
        dateRange: ['', ''],
      },
      queryForm: {
        platForm: 2, // 合作平台：2；中台：1
        type: 1, // 上师大：1，上大：2
        userId: window.localStorage.getItem('userId'),
        pageNo: 1,
        pageSize: 10,
      },
      tableColumn: [
        { id: 'name', name: '报表名称' },
        { id: 'reportFormTime', name: '查询时间维度' },
      ],
      tableData: [],
      total: 0,
    }
  },
  computed: {
    operation: function(){
      return this.$store.getters.operation
    }
  },
  created() {
    this.addQuery.dateRange = [this.$utils.formatDate1(new Date(new Date().setMonth(new Date().getMonth() - 1))), this.$utils.formatDate1(new Date())];
    this.addQuery.name = this.nameList[0].code;
    this.getTableData();
  },
  methods: {
    // 表格序号
    indexMethod(index) {
      // console.log(this.queryForm)
      return this.total - ((this.queryForm.pageSize * (this.queryForm.pageNo - 1)) + index);
    },
    //切换每页显示条数操作
    handleSizeChange(val) {
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = val;
      this.getTableData();
    },
    //切换页码操作
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getTableData();
    },
    // 获取表格数据
    getTableData() {
      this.loading = true;
      let params = {...this.queryForm};
      this.$apiJava.get(this.$apiUrl.schoolReport,params,(res)=>{
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.loading = false;
      },(res)=>{
        this.$message.warning(res.message);
        this.tableData = [];
        this.loading = false;
      },'oc')
    },
    // 重置
    refresh() {
      this.addQuery.dateRange = ['', ''];
      this.addQuery.name = this.nameList[0].code;
    },
    // 生成报表
    addItem() {
      if (!this.addQuery.dateRange[0] || this.addQuery.dateRange[0] == '' || !this.addQuery.dateRange[1] || this.addQuery.dateRange[1] == '') {
        return this.$message.warning('请选择时间');
      }
      if(new Date(this.addQuery.dateRange[1]).getTime() - new Date(this.addQuery.dateRange[0]).getTime() < 0) {
        return this.$message.warning('开始时间不能大于结束时间');
      }
      let param = {
        platForm: 2, // 合作平台：2；中台：1
        type: 1, // 上师大：1，上大：2
        userId: window.localStorage.getItem('userId'),
        name: this.addQuery.name,
        startTime: this.$utils.formatDate1(this.addQuery.dateRange[0]),
        endTime: this.$utils.formatDate1(this.addQuery.dateRange[1]),
      }
      this.$apiJava.get(this.$apiUrl.schoolReportAdd,param,(res)=>{
        this.$message.success('报表查询中，请稍后');
        this.getTableData();
      },(res)=>{
        this.$message.warning(res.message);
      },'oc')
    },
    // 下载报表
    downloadItem(row) {
      let href = window.location.href.split('/report')[0];
      href = (href.indexOf('localhost') >= 0) ? 'http://oc.imcoming.com' : href.replace('e', 'oc');
      href = href + this.$apiUrl.schoolReportDownload + '?id=' + row.id;
      window.open(href);
      // this.$apiJava.get(this.$apiUrl.schoolReportDownload, { id: row.id },(res)=>{
      //   if (res.message != 'success') {
      //     return void this.$message.error('下载失败');
      //   };
      //   // this.downloadName = row.name;
      //   // this.downloadUrl = row.downloadUrl;
      //   // this.$nextTick(() => {
      //   //   document.getElementById('downLoad').click();
      //   // })
      //   window.open(row.downloadUrl);
      // },(res)=>{
      //   this.$message.warning(res.message);
      // },'oc')
    },
    // 删除
    deleteItem(row) {
      this.$confirm('你是否确认删除这个报表?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$apiJava.get(this.$apiUrl.schoolReportDelete,{ id: row.id },(res)=>{
          this.$message.success('删除成功');
          if (this.queryForm.pageSize * (this.queryForm.pageNo - 1) >= this.total) {
            this.queryForm.pageNo = this.queryForm.pageNo - 1;
          }
          this.getTableData();
        },(res)=>{
          this.$message.warning(res.message);
        },'oc')
      }).catch(() => {

      })
    },
    fetch() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    }
  }
}
</script>

<style scoped>
.tab-btn {
  font-size: 12px !important;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// school.vue?e60c0fb0